import React from "react";
import Logo from "../../img/DkLogo-Branco.svg";
import InstagramIcon from "../../img/icons/InstagramIcon.svg";
import WhatsappIcon from "../../img/icons/Whats.svg";
import PhoneIcon from "../../img/icons/PhoneIcon.svg";

import "./footer-style.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__section">
          <h3>Nos conheça</h3>
          <ul>
            <li><a href="#sobre">Sobre nós</a></li>
            <li><a href="#espaco">Nosso Espaço</a></li>
            <li><a href="#reviews">Avaliações</a></li>
          </ul>
        </div>

        <div className="footer__section">
          <h3>Planos</h3>
          <ul>
            <li><a href="#planos">Salas Privativas</a></li>
            <li><a href="#planos">Salas de Reunião</a></li>
            <li><a href="#planos">Estações de Trabalho</a></li>
            <li><a href="#planos">Endereço Fiscal</a></li>
            <li><a href="#planos">Salão de Eventos</a></li>
          </ul>
        </div>

        <div className="footer__section">
          <h3>Contatos</h3>
          <ul>
            <li>
            <img src={InstagramIcon} alt="Instagram" className="footer__icon" />
              <a
                href="https://www.instagram.com/dkcoworkingjabaquara"
                target="_blank"
                rel="noopener noreferrer"
              >
                /dkcoworkingjabaquara
              </a>
            </li>
            <li>
              <img src={WhatsappIcon} alt="WhatsApp" className="footer__icon" />
              <a
                href="https://wa.me/5511970874083"
                target="_blank"
                rel="noopener noreferrer"
              >
                +55 11 97087-4083
              </a>
            </li>
            <li>
              <img src={PhoneIcon} alt="Telefone" className="footer__icon" />
              <span>+55 11 5021-4587</span>
            </li>
          </ul>
        </div>
      </div>

      <hr className="footer__divider" />

      <div className="footer__bottom">
        <img src={Logo} alt="DK Coworking Jabaquara" className="footer__logo" />

        <div className="footer__socials">
        </div>
      </div>

      <p className="footer__copy">
        © 2025 DK Coworking. Todos os direitos reservados
      </p>
    </footer>
  );
};

export default Footer;
